import { useSelector } from "react-redux";

export const useEnums = () => {
    return useSelector((state) => state.Enums.awsUrl?.env?.AWS_S3_URL);
};
